import { useMediaQuery, useTheme } from '@mui/material'
import { Navigate, Outlet } from 'react-router-dom'
import { memo } from 'react'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import { useOrgTypeCheck } from '../components/AccountTypeCheck'
import { SCHOOL_LOADING_ERROR_CODES } from '../../../components/LoadingSpinner/loadingErrorCodes'
import { useSchoolCheck } from './hooks/useSchoolCheck'

// Layout used at the /dashboard/school level -> ensures the users account type allows for schools.
const SchoolDashboard = () => {
    const loading = useOrgTypeCheck('school')
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    useSchoolCheck()

    if (isMobile) {
        return <Navigate to={'/download'} />
    }

    if (loading)
        return (
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                id="school-dashboard-typecheck"
                errorCode={SCHOOL_LOADING_ERROR_CODES.SCHOOL_TYPE_CHECK.code}
            />
        )
    return <Outlet />
}

export default memo(SchoolDashboard)
